import { formatDistanceToNow } from 'date-fns';

interface VersionSelectProps {
  versions: { version: number; createdAt: string }[];
  value: number;
  latest: number | null;
  onChange: (version: number) => void;
}

export function VersionSelect({ versions, value, latest, onChange }: VersionSelectProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      aria-label="Version"
      className="text-xs rounded-md border border-black/10 dark:border-white/10 bg-transparent px-2 py-1.5"
    >
      {versions.map((v) => (
        <option key={v.version} value={v.version}>
          v{v.version}
          {v.version === latest ? ' (latest)' : ''}
          {' — '}
          {formatDistanceToNow(new Date(v.createdAt), { addSuffix: true })}
        </option>
      ))}
    </select>
  );
}
